import React from "react"

export default function Drag() {
  return (
    <symbol id="svg-drag" viewBox="0 0 36 36">
      <path
        fill="currentColor"
        d="M18 6l5.7 5.5-1.2 1.2-3.6-3.5v8.1h-1.7V9.2l-3.6 3.5-1.2-1.2L18 6zm-.9 12.7h1.7v8.1l3.6-3.5 1.2 1.2L18 30l-5.7-5.5 1.2-1.2 3.6 3.5v-8.1z"
      />
    </symbol>
  )
}
